import React from 'react';

export function Tick(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="prefix__feather prefix__feather-check"
            {...props}
        >
            <path d="M20 6L9 17l-5-5" />
        </svg>
    );
}
